import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '@components/base.component';
import { InjuryService } from '@services/injury.service';
import { Subscription } from 'rxjs';
import { InjuryInterface } from '@interfaces/injuries.interface';
import $ from '@shared/jquery';

@Component({
    selector: 'app-injuries',
    templateUrl: './injuries.component.html',
    styleUrls: ['./injuries.component.scss'],
})
export class InjuriesComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public tournamentId?: number;

    @Input()
    public participantId?: number;

    @Input()
    public playerId?: number;

    @Input()
    public showPracticeStatus: boolean = true;

    public subscriber: Subscription;

    public injuries: InjuryInterface[] | null = null;

    public constructor(private injuryService: InjuryService) {
        super();
    }

    ngOnInit(): void {
        this.load();
    }

    public ngOnDestroy(): void {
        $('[data-toggle="tooltip"]').tooltip('dispose');
        this.subscriber?.unsubscribe();
    }

    private async load(): Promise<any> {
        try {
            const data = await this.injuryService.getInjuries(this.tournamentId, this.participantId, this.playerId);

            this.subscriber = data.subscribe((data: InjuryInterface[]) => {
                this.injuries = data;

                // setTimeout(() => {
                //     $('[data-toggle="tooltip"]').tooltip('hide');
                // }, 300);
            });
        } catch (e) {
            undefined;
        }
    }

    get showParticipant(): boolean {
        return !this.participantId && !this.playerId;
    }

    get showPlayer(): boolean {
        return !this.playerId;
    }
}
